<template>
  <div
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
    @click.self="handleCancel"
  >
    <div class="bg-white rounded-xl p-6 max-w-md w-full">
      <!-- Header with Google Logo -->
      <div class="text-center mb-6">
        <div class="flex justify-center mb-4">
          <svg class="w-12 h-12" viewBox="0 0 24 24">
            <path
              fill="#4285F4"
              d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
            />
            <path
              fill="#34A853"
              d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
            />
            <path
              fill="#FBBC05"
              d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
            />
            <path
              fill="#EA4335"
              d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
            />
          </svg>
        </div>
        <h2 class="text-2xl font-bold mb-2">{{ $t('oauth.google.title') }}</h2>
        <p class="text-gray-600 text-sm">
          {{ $t('oauth.google.subtitle') }}
        </p>
      </div>

      <!-- Information -->
      <div class="bg-blue-50 border border-blue-100 rounded-lg p-4 mb-6">
        <h3 class="font-semibold text-gray-900 mb-2 text-sm">
          {{ $t('oauth.google.whatHappens') }}
        </h3>
        <ul class="text-sm text-gray-700 space-y-2">
          <li class="flex items-start gap-2">
            <span class="text-blue-600 mt-0.5">✓</span>
            <span>{{ $t('oauth.google.step1') }}</span>
          </li>
          <li class="flex items-start gap-2">
            <span class="text-blue-600 mt-0.5">✓</span>
            <span>{{ $t('oauth.google.step2') }}</span>
          </li>
          <li class="flex items-start gap-2">
            <span class="text-blue-600 mt-0.5">✓</span>
            <span>{{ $t('oauth.google.step3') }}</span>
          </li>
        </ul>
      </div>

      <!-- Data Sharing Notice -->
      <div class="text-xs text-gray-500 mb-6 text-center">
        <p>{{ $t('oauth.google.dataSharing') }}</p>
      </div>

      <!-- Actions -->
      <div class="flex gap-3">
        <button
          type="button"
          @click="handleCancel"
          class="btn btn-secondary flex-1"
        >
          {{ $t('common.cancel') }}
        </button>
        <button
          type="button"
          @click="handleContinue"
          class="btn btn-primary flex-1"
        >
          {{ $t('oauth.google.continue') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
const emit = defineEmits(['confirm', 'cancel'])

const handleContinue = () => {
  emit('confirm')
}

const handleCancel = () => {
  emit('cancel')
}
</script>
